const moduleRoute = {
  path: '/financeiro',
  component: () => import('@/views/Home.vue'),
  children: [
    {
      path: '',
      component: () => import('./views/Home.vue'),
      children: [
        // Dashboard — tela em React (MU-6C); o wrapper só monta o App.
        {
          path: '',
          component: () => import('@/views/Financeiro/DashboardReact.vue')
        },
        {
          path: 'dashboard',
          component: () => import('@/views/Financeiro/DashboardReact.vue')
        },
        {
          // Sessão de Caixa — aba do Financeiro, conteúdo em React. As pills
          // (Meu caixa / Caixas abertos / Caixas cadastrados) ficam em estado
          // local dentro do React, NÃO na URL.
          //
          // O motivo original já não vale: a casca comparava o caminho por
          // igualdade exata e qualquer `/financeiro/<aba>/<algo>` caía no
          // Dashboard na montagem. O `c1889e381` (casca em React) passou a
          // casar por PREFIXO de segmento — `/financeiro/conciliacao/manual`
          // abre a aba certa. Levar as pills para a URL virou possível, e é
          // card próprio (deep link para "Caixas abertos").
          path: 'sessao_de_caixa',
          component: () => import('@/views/CashSession/CashSessionReact.vue')
        },
        {
          // Fluxo de caixa — tela em React (MU-6C); o wrapper monta o App e
          // ainda hospeda o CashFlowDetailsModal Vue até o porte das contas.
          path: 'fluxo_de_caixa',
          component: () => import('@/views/Financeiro/FluxoDeCaixaReact.vue')
        },
        {
          path: 'contas_a_receber',
          // MU-6C: a tela vive em React; o wrapper hospeda os modais Vue
          // compartilhados (lote, ajuste, impressão e anexos).
          component: () => import('@/views/Financeiro/ContasAReceberReact.vue')
        },
        {
          path: 'contas_a_pagar',
          // MU-6C: a tela vive em React; o wrapper hospeda os modais Vue
          // (lote, ajuste de parcela, impressão e anexos).
          component: () => import('@/views/Financeiro/ContasAPagarReact.vue')
        },
        {
          // Movimentações — aba inteira em React (MU-6C); o wrapper só monta o App.
          path: 'movimentacoes',
          component: () => import('@/views/Financeiro/MovimentacoesReact.vue')
        },
        {
          path: 'transacoes',
          // MU-6C: a tela vive em React; o wrapper hospeda os modais Vue
          // compartilhados com Entradas/Saídas (lote + ajuste de parcela).
          component: () => import('@/views/Financeiro/TransacoesReact.vue')
        },
        {
          path: 'conciliacao',
          // A casca vive em React desde a etapa 7b-2 do MU-6E; segue sendo um
          // `.vue` porque é rota PAI e hospeda o `<router-view>` das filhas.
          component: () =>
            import('@/views/Financeiro/ConciliacaoCascaReact.vue'),
          children: [
            {
              // Escolha manual × automática — tela em React (MU-6E, etapa 3);
              // o wrapper emite as duas saídas para o index.vue, que ainda é
              // quem abre o modal de importação de OFX.
              path: '',
              name: 'financial-conciliacao',
              component: () =>
                import('@/views/Financeiro/ConciliacaoEscolhaReact.vue')
            },
            {
              // Conciliação manual — tela em React (MU-6E, etapa 4).
              //
              // O aninhamento saiu junto do `Manual.vue`: ele existia para
              // hospedar os totais e as pills acima de um `<router-view>` que
              // renderizava o MESMO componente nas três sub-rotas. Agora as
              // três apontam para o mesmo wrapper, que lê a aba do path — o
              // deep link continua valendo e sobrou um nível a menos.
              path: 'manual',
              redirect: 'manual/pending'
            },
            {
              path: 'manual/pending',
              name: 'financial-conciliacao-manual-pending',
              component: () =>
                import('@/views/Financeiro/ConciliacaoManualReact.vue')
            },
            {
              path: 'manual/reconciled',
              name: 'financial-conciliacao-manual-reconciled',
              component: () =>
                import('@/views/Financeiro/ConciliacaoManualReact.vue')
            },
            {
              path: 'manual/archived',
              name: 'financial-conciliacao-manual-archived',
              component: () =>
                import('@/views/Financeiro/ConciliacaoManualReact.vue')
            },
            {
              path: 'automatica',
              name: 'financial-conciliacao-automatica',
              component: () =>
                import('@/views/Financeiro/ConciliacaoAutomaticaReact.vue')
            },
            {
              // Arquivados do extrato (todas as contas da unidade) — tela em
              // React (MU-6E, etapa 3).
              path: 'arquivados',
              name: 'financial-conciliacao-arquivados',
              component: () =>
                import('@/views/Financeiro/ConciliacaoArquivadosReact.vue')
            }
          ]
        },
        {
          // Favorecido — aba inteira em React (MU-6C); o wrapper só monta o App.
          path: 'favorecidos',
          component: () => import('@/views/Financeiro/FavorecidosReact.vue')
        },
        {
          // Crédito do paciente — tela em React (MU-6C); o wrapper monta o App
          // e repassa onEditBillsToReceive/reactRefreshToken do Home.vue.
          path: 'credito_paciente',
          component: () => import('@/views/Financeiro/PatientCreditReact.vue')
        },
        {
          path: 'configuracoes',
          component: () => import('./views/Configurations.vue')
        }
      ]
    },
    {
      path: 'pendings',
      redirect: 'pendings/dashboard'
    },
    {
      // Gerenciar pendências — abas em React (MU-6C). MESMO wrapper nas duas
      // rotas: o Vue Router reusa a instância e o wrapper observa o $route
      // para trocar a aba; os modais de guia/conta/NFS-e vivem no wrapper.
      path: 'pendings/dashboard',
      component: () => import('@/views/Financeiro/PendenciasReact.vue')
    },
    {
      path: 'pendings/history',
      component: () => import('@/views/Financeiro/PendenciasReact.vue')
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
